import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Icon from 'components/icon';

export default class Loader extends PureComponent {
    static propTypes = {
        facet: PropTypes.string,
        size: PropTypes.string,
        symbol: PropTypes.string,
        pulsate: PropTypes.bool,
    };

    static defaultProps = {
        pulsate: true,
    };

    render() {
        const { facet, size, symbol, pulsate } = this.props;
        return (
            <div className={classnames('loader', `loader__${ facet || 'default' }`, { [`loader__${ size }`]: size })}>
                {facet === 'icon'
                    ? <Icon size={size} symbol={symbol}
                        className={classnames('loader--icon', { 'loader--icon__pulsate': pulsate })}/>
                    : <div className="loader--container">
                        <svg className="loader--circle" viewBox="16 16 32 32">
                            <circle className="loader--bg" cx="32" cy="32" r="14" fill="none"/>
                            <circle className="loader--path" cx="32" cy="32" r="14" fill="none"/>
                        </svg>
                    </div>
                }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/loader/index.js